// extracted by mini-css-extract-plugin
export var buttonPadding = "StreamingEuPage-module__buttonPadding___54UgN";
export var checkBoxWrapper = "StreamingEuPage-module__checkBoxWrapper___GBjog";
export var container = "StreamingEuPage-module__container___dkAA-";
export var contentBox = "StreamingEuPage-module__contentBox___TxqZ7";
export var horizontalCentering = "StreamingEuPage-module__horizontalCentering___HmYEO";
export var innerContentBox = "StreamingEuPage-module__innerContentBox___CpYTH";
export var inputSpace = "StreamingEuPage-module__inputSpace___2WT1E";
export var inputTitle = "StreamingEuPage-module__inputTitle___j6HMu";
export var mandatoryFieldAsterisk = "StreamingEuPage-module__mandatoryFieldAsterisk___KkOyv";
export var scrollBox = "StreamingEuPage-module__scrollBox___Z6YcD";
export var spinnerBackground = "StreamingEuPage-module__spinnerBackground___rg788";
export var title = "StreamingEuPage-module__title___OUC+f";
export var verticalCentering = "StreamingEuPage-module__verticalCentering___WdCu6";